/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlUpdateContactEmailRequest
 */
export interface ControlUpdateContactEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateContactEmailRequest
     */
    email: string;
}

/**
 * Check if a given object implements the ControlUpdateContactEmailRequest interface.
 */
export function instanceOfControlUpdateContactEmailRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function ControlUpdateContactEmailRequestFromJSON(json: any): ControlUpdateContactEmailRequest {
    return ControlUpdateContactEmailRequestFromJSONTyped(json, false);
}

export function ControlUpdateContactEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUpdateContactEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function ControlUpdateContactEmailRequestToJSON(value?: ControlUpdateContactEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

